/**
 *
 */
const filterByBranchOfficeId = id => ({ branch_office_id }) =>
    branch_office_id === id

/**
 *
 */
const reduceGainsMargin = (prev, curr) =>
    parseFloat(prev.gains_margin || 0) + parseFloat(curr.gains_margin || 0)

/**
 *
 */
const reduceSalePrice = (prev, curr) =>
    parseFloat(prev.sale_price || 0) + parseFloat(curr.sale_price || 0)

//
export default branch_office_id => [
    {
        text: 'CODIGO INTERNO',
        value: 'internal_code',
    },
    {
        text: 'NOMBRE',
        value: 'name',
    },
    {
        text: 'ALIAS',
        value: 'alias_name',
    },
    {
        text: 'CONSUMIBLE',
        value: 'is_consumable',
    },
    {
        text: 'PRECIO VENTA',
        computed: product =>
            product.sale_prices
                .filter(filterByBranchOfficeId(branch_office_id))
                .reduce(reduceSalePrice, 0),
        fieldType: 'computed',
    },
    {
        value: 'virtual_sale_price',
        text: 'NUEVO PRECIO VENTA',
        fieldType: 'text',
        fieldProps: {
            prefix: '$',
        },
        editable: true,
        format: ['currency'],
    },
]

//
export { filterByBranchOfficeId, reduceGainsMargin, reduceSalePrice }
